import type { FormikHelpers } from 'formik';

import type { PhoneSurveyConfigurationModel } from '~/server_shared/openapi/data-contracts';

export const handleFormSubmit = async (
  values: PhoneSurveyConfigurationModel,
  formikHelpers: FormikHelpers<PhoneSurveyConfigurationModel>,
  onSubmit: (values: PhoneSurveyConfigurationModel) => Promise<void>,
  onCancel: () => void
) => {
  try {
    await onSubmit(values);
    onCancel();
  } catch (error) {
    formikHelpers.setSubmitting(false);
  }
};
